import React, { useState } from "react";

export const YoutubeStep = React.forwardRef((props, ref) => {
    return (
        <div ref={ref} className={`c-youtube__step ${props.isActive ? "active" : ""}`}>
            <span className="c-youtube__step__timestamp">
                {props.step.timestamp.minutes < 10 ? "0" + props.step.timestamp.minutes : props.step.timestamp.minutes}:{props.step.timestamp.seconds < 10 ? "0" + props.step.timestamp.seconds : props.step.timestamp.seconds}
            </span>
            <div className="c-youtube__step__description">
                <p>
                    {props.step.description}
                </p>
            </div>
    
            {props.step.tip !==
                null && props.isActive && (
                    <div className="c-youtube__step__tip">
                        <div className="c-youtube__step__tip-title">
                            <svg
                                width="9"
                                height="12"
                                viewBox="0 0 9 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2.25 11.1641C2.25 11.3047 2.27344 11.4453 2.36719 11.5859L2.76562 12.1719C2.88281 12.3594 3.16406 12.5234 3.39844 12.5234H4.82812C5.0625 12.5234 5.34375 12.3594 5.46094 12.1719L5.85938 11.5859C5.92969 11.4688 5.97656 11.2812 5.97656 11.1641V10.25H2.25V11.1641ZM0 4.625C0 5.67969 0.375 6.61719 1.00781 7.34375C1.40625 7.78906 1.99219 8.72656 2.22656 9.5C2.22656 9.5 2.22656 9.5 2.22656 9.52344H6C6 9.5 6 9.5 6 9.5C6.23438 8.72656 6.82031 7.78906 7.21875 7.34375C7.85156 6.61719 8.25 5.67969 8.25 4.625C8.25 2.35156 6.375 0.5 4.10156 0.5C1.71094 0.523438 0 2.44531 0 4.625ZM4.125 2.75C3.07031 2.75 2.25 3.59375 2.25 4.625C2.25 4.83594 2.0625 5 1.875 5C1.66406 5 1.5 4.83594 1.5 4.625C1.5 3.19531 2.67188 2 4.125 2C4.3125 2 4.5 2.1875 4.5 2.375C4.5 2.58594 4.3125 2.75 4.125 2.75Z"
                                    fill="#0055CC"
                                />
                            </svg>
                            <span>{props.dictionary.tip}</span>
                        </div>
                        <p className="c-youtube__step__tip-description">
                            {props.step.tip}
                        </p>
                    </div>
                )}
        </div>
    )
})